import { z } from 'zod';
/**
 * `failedSince` y `receptionsSince`: instante en que el usuario cerró cada aviso; el aviso solo cuenta lo
 * que llegó después (comprobantes creados o recibidos posteriores).
 */
export const dashboardQuery = z.object({
    branchId: z.uuid().optional(),
    failedSince: z.iso.datetime().optional(),
    receptionsSince: z.iso.datetime().optional(),
});
export const REPORTS = [
    {
        key: 'invoices',
        name: 'Facturas',
        description: 'Facturas electrónicas con las notas de crédito y débito aplicadas a cada una.',
    },
    {
        key: 'tickets',
        name: 'Tiquetes',
        description: 'Tiquetes electrónicos con sus notas, IVA devuelto y total neto.',
    },
    {
        key: 'notes',
        name: 'Notas de crédito y débito',
        description: 'Notas emitidas y el comprobante al que pertenecen.',
    },
    {
        key: 'sales',
        name: 'Ventas',
        description: 'Comprobantes emitidos con subtotal, descuento, IVA y total.',
    },
    {
        key: 'tax',
        name: 'IVA (D-104)',
        description: 'Débito y crédito fiscal por tarifa para la declaración mensual.',
    },
    { key: 'purchases', name: 'Compras', description: 'Comprobantes recibidos y su respuesta ante Hacienda.' },
    { key: 'expenses', name: 'Gastos por categoría', description: 'Gastos del año por categoría y mes.' },
    {
        key: 'products',
        name: 'Ventas por producto',
        description: 'Cantidades y montos vendidos por producto o servicio.',
    },
    {
        key: 'receivables',
        name: 'Cuentas por cobrar',
        description: 'Facturas con saldo pendiente y su antigüedad.',
    },
    {
        key: 'customers',
        name: 'Ventas por cliente',
        description: 'Total facturado, cobrado y pendiente por cliente.',
    },
];
export const reportQuery = z.object({
    from: z.iso.date(),
    to: z.iso.date(),
    kind: z.string().optional(),
    /** Solo comprobantes de esta sucursal. */
    branchId: z.uuid().optional(),
    /** Estado ante Hacienda (accepted, rejected, pending…); por defecto todos menos los rechazados. */
    status: z.string().optional(),
    /** Consecutivo, clave, nombre o cédula. */
    search: z.string().trim().max(80).optional(),
    /** Solo para el reporte de notas. */
    noteType: z.enum(['NC', 'ND']).optional(),
    /** Solo para el reporte de gastos: una categoría. */
    categoryId: z.uuid().optional(),
    /** Solo para el reporte de compras: respuesta dada al proveedor (`pending` = sin responder). */
    decision: z.enum(['pending', '1', '2', '3']).optional(),
    /** Paginación de la vista en pantalla (Excel siempre trae todo). Los totales son del conjunto completo. */
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(10).max(1000).default(200),
    format: z.enum(['json', 'xlsx']).default('json'),
});
//# sourceMappingURL=analytics.js.map